import React, { useEffect, useState } from "react";
import { getTipoDeDocumento, postPacientesParaProgramacionCirugia } from "../../../services/PaginaRuta";
import Loading from "../../Loading";
import TablaListaDeSeleccionPacientesXNombreN from "./TablaListaDeSeleccionPacientesXNombreN";

const ModalListaDeSeleccionPacientesXNombreN = ({  setmodalOnSeleccionPaciente,passDataInfoUser }) => {
    const [loading,setLoading]=useState(true)
    const [tipoDocumento, settipoDocumento]=useState([])
    const [dataUser, setDataUser]=useState([])
    const [errorSeleccionarNombreOUnNumerodeIdentificacion, seterrorSeleccionarNombreOUnNumerodeIdentificacion]=useState('')
  const handleCancelarClick = () => {
    setmodalOnSeleccionPaciente(false);
  };

  const passBuscarDataUser=(data)=>{
    passDataInfoUser(data)
    setmodalOnSeleccionPaciente(false);
  }

  const handleOnsubmitBuscarPaciente=(e)=>{
    e.preventDefault()
    if(errorSeleccionarNombreOUnNumerodeIdentificacion == ''){ 
      
      setLoading(false)
      const buscar={
        varMPNOMC: e.target.nombrePaciente.value,
        varMPCedu: e.target.numeroDelDocumento.value,
        varMPTDoc: e.target.tipoDocumento.value
      }
      //console.log(buscar,'buscar paciente')
      postPacientesParaProgramacionCirugia(buscar).then((res)=>{
        //console.log(res.data,'data pacientess')
        setLoading(true)
        setDataUser(res.data)
      })
    }
  }
  useEffect(()=>{
    seterrorSeleccionarNombreOUnNumerodeIdentificacion('Seleccionar un nombre o un número de documento')
    getTipoDeDocumento().then((res)=>{
      settipoDocumento(res.data)
    })
  },[])
  const handleOnchangeNombre=(e)=>{
    if(e.target.value){
      seterrorSeleccionarNombreOUnNumerodeIdentificacion('')
    }else{
      seterrorSeleccionarNombreOUnNumerodeIdentificacion('Seleccionar un nombre o un número de documento')
    }
  }
  
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] max-w-7xl  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#9e56fe]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Lista de Selección Pacientes X Nombre
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-4">
            <form onSubmit={handleOnsubmitBuscarPaciente}>
              <div className="flex py-1 text-left">
                <div className="w-3/12  px-4">
                  <label className="form-label inline-block mb-1 text-gray-900 font-medium">
                    Número documento
                  </label>
                  <div className="flex">
                    <input
                      //   onChange={searchUserId}
                      //defaultValue={props.userDate[0].ProEmpCod}
                      //defaultValue={props.userDate.ProEmpCod}
                      type="text"
                      name="numeroDelDocumento"
                      onChange={handleOnchangeNombre}
                      autoComplete="off"
                      className="form-control block w-full px-3 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="w-3/12  px-4 ">
                    <label className="form-label block mb-2 text-gray-900 font-medium">Tipo de documento</label>
                    <select
                      //defaultValue={item.ViaCod}
                      name="tipoDocumento"
                      className="form-select block  w-full px-3 py-0.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                    >
                      {
                        tipoDocumento.map((item,index)=>(
                          <option value={item.MPTDoc} key={index}>{item.MPTDoc}</option>
                        ))
                      }
                      
                    </select>
                </div>
                <div className="w-3/12  px-4">
                  <label className="form-label block mb-2 text-gray-900 font-medium ">
                   Nombre
                  </label>
                  <div className="flex">
                    <input
                      //   onChange={searchUserId}
                      //defaultValue={props.userDate[0].ProEmpCod}
                      //defaultValue={props.userDate.ProEmpCod}
                      onChange={handleOnchangeNombre}
                      type="text"
                      name="nombrePaciente"
                      autoComplete="off"
                      className="form-control block w-full px-3 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="w-3/12  px-4">
                  <label className="form-label block mb-2 text-gray-900 font-medium pt-6">
                    
                  </label>
                  <div className="flex">
                  <button
                      type="submit"
                      className="inline-block px-6 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    >
                      Buscar
                    </button>
                  </div>
                </div>
              </div>
              
            </form>
            <div className="flex text-left">
              <div className="px-4">
                <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {errorSeleccionarNombreOUnNumerodeIdentificacion}
                </label>
              </div>
            </div>
            <div className="flex flex-col">
              <div className="overflow-x-auto ">
                <div className="py-2 inline-block min-w-full sm:px-6 ">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-center">
                      <thead className="border-b bg-gray-200">
                        <tr>
                        <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-2"
                          >
                            
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-2"
                          >
                            Nombre Completo Paciente
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-2"
                          >
                            Sexo
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-2"
                          >
                            Cédula 
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-6 py-2"
                          >
                            Tipo Doc
                          </th>
                          
                        </tr>
                      </thead>
                      <tbody>
                        {
                          loading?
                          dataUser.map((item,index)=>(
                            <TablaListaDeSeleccionPacientesXNombreN key={index} item={item} passBuscarDataUser={passBuscarDataUser}/>
                          ))
                          :
                          <tr>
                      <td></td>
                      <td></td>
                      <td className='text-center'><Loading/></td>
                      <td></td>
                      <td></td>
                      
                    </tr>
                        }
                       
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cancelar
            </button>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalListaDeSeleccionPacientesXNombreN;
